import { NameDto } from './NameDto'

export interface RewardsHubDashboardDto {
  monthlyTradedVolume: number
  availableToJoin: number
  trackingProgress: number
  rewardsToClaim: number
  campaignsAvailableToJoin: CampaignsAvailableToJoinDto[]
  campaignsInProgress: CampaignsInProgressDto
  campaignsResults: { tradingPools: TradingPoolTypeDto[] }
}

export interface CampaignsAvailableToJoinDto {
  campaign: NameDto<string>
  description: string
  type: NameDto<number>
  termsAndConditionsUrl: string
  joinDate: string
  startDate: string
  tradingPool: { currentPrizePool: number; drawDate: string }
}

export interface CampaignsInProgressDto {
  tradingViewCouponReward: TradingViewCouponRewardDto | null
  marginBonus: MarginBonusDto | null
  clientContests: ClientContestDto[]
  clientRebateTiers: ClientRebateTiersDto | null
  clientRebateAccountType: ClientRebateAccountTypeDto | null
  tradingPools: TradingPoolTypeDto[]
}

export interface TradingPoolTypeDto {
  tradingAccount: NameDto<string>
  campaign: NameDto<string>
  currentPrizePool: number
  drawDate: string
  joinDate: string
  status: NameDto
  totalParticipants: number
  entries: number
  lotsPerEntry: number
  progressToNextEntry: number
}

export interface TradingViewCouponRewardDto {
  tradingAccount: NameDto<string>
  monthlyTradedVolume: number
  joinDate: string
}

export interface MarginBonusDto {
  campaign: NameDto<string>
  netDeposit: number
  netCredit: number
  currency: NameDto<string>
  endDate: string
  termsAndConditionsUrl: string
  joinDate: string
}

export interface ClientContestDto {
  campaign: NameDto<string>
  rank: number
  contestPoints: number
  currency: NameDto<string>
  termsAndConditionsUrl: string
  joinDate: string
  tradingAccount: NameDto<string>
}

export interface TierDto {
  tier: number
  multiplier: number
}

export interface ClientRebateTiersDto {
  campaign: NameDto<string>
  currentTier: number
  tiers: TierDto[]
  currency: NameDto<string>
  termsAndConditionsUrl: string
  joinDate: string
  tradingAccount: NameDto<string>
}

export interface ClientRebateAccountTypeDto {
  campaign: NameDto<string>
  multiplier: number
  cashbackEarned: number
  currency: NameDto<string>
  termsAndConditionsUrl: string
  joinDate: string
  tradingAccount: NameDto<string>
}

export interface TradingPoolResultTypeDto {
  rank: number
  account: string
  entries: number
}

export interface TradingPoolCampaignDetailDto {
  campaign: NameDto
  drawTime: string
  entriesPerLot: number
  summary: {
    status: NameDto
    prizePool: number
    totalEntries: number
    totalParticipants: number
  }
  clientResult: {
    tradingAccount: string
    lotsTraded: number
    raffleEntries: number
    rank: number
    prizeInUsd: number | null
    progressToNextEntry: number
    lotsPerEntry: number
  }
}

export interface TradingPoolCampaignDetailsAboutModal {
  description: string
  startDate: string
  endDate: string
  instruments: string[]
  entriesPerLot: number
  contributionPerLotInUsd: number
  winnersCount: number
  termsAndConditionsUrl: string
}

export enum TradingPoolCampaignStatus {
  ACTIVE = 1,
  ENDED_DRAW_PENDING = 2,
  ENDED = 3,
}
